import { SVG, SVGProps } from './svg'

export function IconChartTable(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M20 4H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM4 9V6h16v3H4Zm16 1.8h-4V18h4v-7.3Zm-10.3 0h4.6V18H9.7v-7.3Zm-1.7 0H4V18h4v-7.3Z"
      />
    </SVG>
  )
}
